import Vue from "vue"
import { initialState } from "./state"

export const setRefresh = (state, refresh) => {
  Vue.set(state.refreshes, refresh.podcastKey, refresh)
}

export const removeRefresh = (state, podcastKey) => {
  Vue.delete(state.refreshes, podcastKey)
}

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
